import {Injectable} from '@angular/core';
import {AppConfigService, LocalizationService} from '@npck/libs/commons';
import {StatusStyle} from '../components/status/status.component';
import {LAST_ALLOWED_DAYS_LEFT, PASSWORD_EXPIRY_WARNING_DAYS} from './constants';

const EMPTY_VALUE = '—';

@Injectable({
    providedIn: 'root',
})
export class PasswordExpiryStatusService {

    constructor(private localizationService: LocalizationService) {
    }

    get lastAllowedDays(): number {
        return this.config()?.passwordExpiryLastAllowedDays ?? LAST_ALLOWED_DAYS_LEFT;
    }

    private get warningDays(): number {
        return this.config()?.passwordExpiryWarningDays ?? PASSWORD_EXPIRY_WARNING_DAYS;
    }

    status(daysLeft?: number): PasswordExpiryStatus {
        if (daysLeft === null || daysLeft === undefined) {
            return {text: EMPTY_VALUE, style: StatusStyle.INACTIVE};
        }
        if (daysLeft < this.lastAllowedDays) {
            return {
                text: this.localizationService.getLocalizedKey('i18n_af_labelPasswordExpiryExpired'),
                style: StatusStyle.ERROR,
            };
        }
        return this.isExpiring(daysLeft)
            ? {text: this.daysText('i18n_af_labelPasswordExpirySoon', daysLeft), style: StatusStyle.WARNING}
            : {text: this.daysText('i18n_af_labelPasswordExpiryActive', daysLeft), style: StatusStyle.SUCCESS};
    }

    isExpiring(daysLeft?: number): boolean {
        return daysLeft !== null && daysLeft !== undefined
            && daysLeft >= this.lastAllowedDays && daysLeft <= this.warningDays;
    }

    private config(): PasswordExpiryConfig {
        return AppConfigService.config<PasswordExpiryConfig>();
    }

    private daysText(key: string, daysLeft: number): string {
        return this.localizationService.getLocalizedKey(key, {count: String(daysLeft)});
    }
}

interface PasswordExpiryConfig {
    passwordExpiryWarningDays?: number;
    passwordExpiryLastAllowedDays?: number;
}

export interface PasswordExpiryStatus {
    text: string;
    style: StatusStyle;
}
